import React from "react";

import { formatISO, parseISO } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { DatePicker } from "@material-ui/pickers";

import { InputLabel } from "@material-ui/core";

import { useTranslation } from "react-i18next";

import { getDateLocale } from "lib/date-locale";

export default function DateSelector({
  date,
  onDateChange,
  minDate,
  maxDate,
  label,
}) {
  const { i18n } = useTranslation();

  const minDateDate = parseISO(minDate);
  const maxDateDate = parseISO(maxDate);

  const handleBaselineChange = (date) => {
    const isoDate = formatISO(date, { representation: "date" });
    onDateChange(isoDate);
  };

  const shouldDisableDate = (date) => {
    return date > maxDateDate || date < minDateDate;
  };

  const locale = getDateLocale(i18n.language);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
      <>
        {label ? (
          <InputLabel shrink id="country-select-label">
            {label}
          </InputLabel>
        ) : undefined}
        <DatePicker
          style={{ width: "100%" }}
          autoOk
          variant="inline"
          shouldDisableDate={shouldDisableDate}
          value={parseISO(date)}
          onChange={handleBaselineChange}
        />
      </>
    </MuiPickersUtilsProvider>
  );
}
